export default "__VITE_ASSET__DYEsjjIP__"